import { render, staticRenderFns } from "./ClubLayout.vue?vue&type=template&id=e4a6332c"
import script from "./ClubLayout.vue?vue&type=script&lang=js"
export * from "./ClubLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports